// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"589c9733","576":"cbfb5c5c","617":"c855ac56"}[chunkId] + ".chunk.css";
};